/* PP Halloween 2026 — comportamiento de la landing /pages/halloween */
(function () {
    /* Cada sección carga este archivo: solo se ejecuta la primera vez para no duplicar clics */
  if (window.__ppHalloweenLoaded) return;
  window.__ppHalloweenLoaded = true;
  function money(cents, el) {
    var cur = (el && el.dataset.currency) || 'EUR';
    var loc = (el && el.dataset.locale) || document.documentElement.lang || 'es';
    try { return new Intl.NumberFormat(loc, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }

  async function addToCart(items, button) {
    if (!items.length) return;
    var label = button ? button.querySelector('[data-hw-label]') || button : null;
    var original = label ? label.textContent : '';
    if (button) button.classList.add('is-loading');
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!res.ok) {
        var err = await res.json().catch(function () { return {}; });
        throw new Error(err.description || err.message || 'No se pudo añadir al carrito');
      }
      var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:add', { detail: { cart: cart } }));
      if (typeof window.ppRefreshCartDrawer === 'function') {
        await window.ppRefreshCartDrawer({ open: true });
      } else {
        window.location.href = '/cart';
        return;
      }
      if (label) {
        label.textContent = '✓ Añadido';
        setTimeout(function () { label.textContent = original; }, 1800);
      }
    } catch (e) {
      console.error('PP Halloween:', e);
      alert(e.message);
    } finally {
      if (button) button.classList.remove('is-loading');
    }
  }
  window.ppHalloweenAddToCart = addToCart;

  /* Botones simples: data-hw-add="123,456" (ids de variante) */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-hw-add]');
    if (!btn || btn.disabled) return;
    ev.preventDefault();
    var ids = btn.getAttribute('data-hw-add').split(',').filter(Boolean);
    addToCart(ids.map(function (id) { return { id: Number(id), quantity: 1 }; }), btn);
  });

  /* Mostrar más (kit y plant based) */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-hw-more]');
    if (!btn) return;
    var root = btn.closest('[data-hw-expandable]');
    if (!root) return;
    var open = root.classList.toggle('is-expanded');
    var lbl = btn.querySelector('[data-hw-label]') || btn;
    lbl.textContent = open ? btn.dataset.less : btn.dataset.more;
  });

  /* ---------- Fantasmas ---------- */
  if (!customElements.get('hw-ghosts')) {
    customElements.define('hw-ghosts', class extends HTMLElement {
      connectedCallback() {
        this.tiles = Array.from(this.querySelectorAll('[data-hw-ghost]'));
        this.step = 0;
        this.auto = true;
        var interval = parseInt(this.dataset.interval, 10) || 850;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var self = this;
        this.tiles.forEach(function (tile) {
          tile.addEventListener('click', function (ev) {
            if (ev.target.closest('a')) return;
            self.auto = false;
            tile.classList.toggle('is-open');
            tile.setAttribute('aria-pressed', tile.classList.contains('is-open'));
          });
          tile.addEventListener('keydown', function (ev) {
            if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); tile.click(); }
          });
        });
        if (reduce) { this.tiles.forEach(function (t) { t.classList.add('is-open'); }); return; }
        var cycle = this.tiles.length + 4;
        this.timer = setInterval(function () {
          if (!self.auto) return;
          self.step = (self.step + 1) % cycle;
          self.tiles.forEach(function (t, i) { t.classList.toggle('is-open', i < self.step); });
        }, interval);
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }

  /* ---------- Kit ---------- */
  if (!customElements.get('hw-kit')) {
    customElements.define('hw-kit', class extends HTMLElement {
      connectedCallback() {
        var d = this.dataset;
        this.t1q = parseInt(d.tier1Qty, 10) || 0;
        this.t1p = parseFloat(d.tier1Pct) || 0;
        this.t2q = parseInt(d.tier2Qty, 10) || 0;
        this.t2p = parseFloat(d.tier2Pct) || 0;
        /* Tramo 2 desactivado si su descuento es 0 o no mejora el tramo 1 */
        if (!this.t2p || this.t2p <= this.t1p || this.t2q <= this.t1q) { this.t2q = 0; this.t2p = 0; }
        this.minQ = parseInt(d.min, 10) || 1;
        this.ship = parseInt(d.freeShipping, 10) || 0;
        this.selected = new Map();
        this.pumpkin = this.querySelector('[data-hw-pumpkin]');
        this.bar = this.querySelector('[data-hw-bar]');
        var self = this;

        this.addEventListener('click', function (ev) {
          var item = ev.target.closest('[data-hw-item]');
          if (item && !item.disabled) { ev.preventDefault(); self.toggle(item); return; }
          var all = ev.target.closest('[data-hw-care-all]');
          if (all) { ev.preventDefault(); self.querySelectorAll('[data-hw-group="care"]').forEach(function (c) { if (!c.disabled) self.toggle(c, true); }); return; }
          var submit = ev.target.closest('[data-hw-submit]');
          if (submit && !submit.disabled) { ev.preventDefault(); self.submit(submit); }
        });
        if (this.pumpkin) this.pumpkin.addEventListener('change', function () { self.render(); });

        if (this.bar && 'IntersectionObserver' in window) {
          this.inView = false;
          new IntersectionObserver(function (entries) {
            self.inView = entries[0].isIntersecting; self.render();
          }).observe(this.querySelector('[data-hw-kit-area]') || this);
        }
        this.querySelectorAll('[data-hw-item][aria-pressed="true"]').forEach(function (i) { self.selected.set(i.dataset.variantId, self.info(i)); });
        this.render();
      }
      info(el) { return { id: el.dataset.variantId, price: parseInt(el.dataset.price, 10) || 0, title: el.dataset.title }; }
      toggle(el, forceOn) {
        var on = el.getAttribute('aria-pressed') === 'true';
        var next = forceOn ? true : !on;
        el.setAttribute('aria-pressed', next ? 'true' : 'false');
        if (next) this.selected.set(el.dataset.variantId, this.info(el)); else this.selected.delete(el.dataset.variantId);
        this.render();
      }
      render() {
        var count = this.selected.size, sub = 0, self = this;
        this.selected.forEach(function (i) { sub += i.price; });
        var pct = 0;
        if (this.t2q && count >= this.t2q) pct = this.t2p; else if (this.t1q && count >= this.t1q) pct = this.t1p;
        var disc = Math.round(sub * pct / 100);
        var pumpkinOn = this.pumpkin && this.pumpkin.checked;
        var pumpkinPrice = pumpkinOn ? (parseInt(this.pumpkin.dataset.price, 10) || 0) : 0;
        var total = sub - disc + pumpkinPrice;
        var q = function (s) { return self.querySelectorAll(s); };

        q('[data-hw-count]').forEach(function (e) { e.textContent = count; });
        q('[data-hw-bars] span').forEach(function (b, i) { b.classList.toggle('is-on', count > i); });
        var tier = '';
        if (this.t2q && count >= this.t2q) tier = (this.dataset.msgMax || '').replace('[percent]', this.t2p);
        else if (this.t1q && count >= this.t1q && !this.t2q) tier = (this.dataset.msgMax || '').replace('[percent]', this.t1p);
        else if (this.t1q && count >= this.t1q) tier = (this.dataset.msgMid || '').replace('[percent]', this.t1p).replace('[count]', this.t2q - count).replace('[next]', this.t2p);
        else tier = (this.dataset.msgStart || '').replace('[count]', Math.max(0, this.t1q - count)).replace('[percent]', this.t1p);
        q('[data-hw-tier]').forEach(function (e) { e.textContent = tier; });

        var list = this.querySelector('[data-hw-list]');
        if (list) {
          list.innerHTML = '';
          if (!count && !pumpkinOn) {
            var li = document.createElement('li'); li.className = 'hw-summary__empty'; li.textContent = this.dataset.msgEmpty || ''; list.appendChild(li);
          }
          this.selected.forEach(function (i) {
            var row = document.createElement('li');
            var a = document.createElement('span'); a.textContent = i.title;
            var b = document.createElement('span'); b.textContent = money(i.price, self);
            row.appendChild(a); row.appendChild(b); list.appendChild(row);
          });
          if (pumpkinOn) {
            var pr = document.createElement('li');
            var pa = document.createElement('span'); pa.textContent = this.pumpkin.dataset.title;
            var pb = document.createElement('span'); pb.textContent = money(pumpkinPrice, self);
            pr.appendChild(pa); pr.appendChild(pb); list.appendChild(pr);
          }
        }
        q('[data-hw-subtotal]').forEach(function (e) { e.textContent = money(sub, self); });
        q('[data-hw-discount]').forEach(function (e) { e.textContent = disc ? '−' + money(disc, self) : money(0, self); });
        q('[data-hw-total]').forEach(function (e) { e.textContent = money(total, self); });

        if (this.ship) {
          var left = Math.max(0, this.ship - total);
          var msg = left > 0 ? (this.dataset.msgShip || '').replace('[amount]', money(left, this)) : (this.dataset.msgShipOk || '');
          q('[data-hw-ship]').forEach(function (e) { e.textContent = msg; });
          q('[data-hw-ship-fill]').forEach(function (e) { e.style.width = Math.min(100, Math.round(total / self.ship * 100)) + '%'; });
        }
        var ok = count >= this.minQ;
        q('[data-hw-submit]').forEach(function (b) {
          b.disabled = !ok;
          var l = b.querySelector('[data-hw-label]');
          if (l) l.textContent = ok ? self.dataset.ctaOk : (self.dataset.ctaMin || '').replace('[count]', self.minQ);
        });
        if (this.bar) this.bar.classList.toggle('is-visible', count > 0 && !!this.inView);
      }
      submit(btn) {
        /* Marca oculta (_kit) en cada producto del kit, para un futuro descuento solo-kit (función de Shopify).
           La calabaza va sin marca porque no cuenta para el descuento. */
        var tag = this.dataset.kitTag || 'halloween';
        var items = [];
        this.selected.forEach(function (i) { items.push({ id: Number(i.id), quantity: 1, properties: { _kit: tag } }); });
        if (this.pumpkin && this.pumpkin.checked) items.push({ id: Number(this.pumpkin.dataset.variantId), quantity: 1 });
        addToCart(items, btn);
      }
    });
  }
})();
